import { render } from "./SwatchEdit.vue?vue&type=template&id=119cc4e2"
import script from "./SwatchEdit.vue?vue&type=script&lang=js"
export * from "./SwatchEdit.vue?vue&type=script&lang=js"

import "./SwatchEdit.vue?vue&type=style&index=0&id=119cc4e2&lang=scss"

import exportComponent from "/Users/william/Documents/beadographer3/bead3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__